const ACTION_TYPES = {
  REQUEST_WEATHER_FORECASTS: "REQUEST_WEATHER_FORECASTS",
  RECEIVE_WEATHER_FORECASTS: "RECEIVE_WEATHER_FORECASTS",
  GET_SITE_DATA: "GET_SITE_DATA",
  FETCH_SBG_DATA: "FETCH_SBG_DATA",
  FETCH_SBG_LOCATIONS: "FETCH_SBG_LOCATIONS",
  SET_LOCATION_LIST: "SET_LOCATION_LIST",
  THEME_UPDATE: "THEME_UPDATE",
  GET_USER_DATA: "GET_USER_DATA",
  UPDATE_PIN_SITE: "UPDATE_PIN_SITE",
  FETCH_TIERS: "FETCH_TIERS",
  FETCH_TEMPLATE: "FETCH_TEMPLATE",
  FETCH_PERF_GRID: "FETCH_PERF_GRID",
  FETCH_PEOPLE: "FETCH_PEOPLE",
  FETCH_TABLEUA_DATA: "FETCH_TABLEUA_DATA",
  GET_TIER_INFO: "GET_TIER_INFO",
  REFRESH_GRID: "REFRESH_GRID",
  FETCH_MOC: "FETCH_MOC",
  UPDATE_MOC: "UPDATE_MOC",
  DELETE_MOC: "DELETE_MOC",
  FETCH_GEMBA: "FETCH_GEMBA",
  GET_MESSAGES: "GET_MESSAGES",
  UPDATE_MESSAGES: "UPDATE_MESSAGES",
  GET_DOWNTIME: "GET_DOWNTIME",
  GET_REASON_CODES: "GET_REASON_CODES",
  UPDATE_DOWNTIME_METRIC: "UPDATE_DOWNTIME_METRIC",
  DELETE_DOWNTIME_METRIC: "DELETE_DOWNTIME_METRIC",
  ADD_DOWNTIME_METRIC: "ADD_DOWNTIME_METRIC",
  GET_ALERTS: "GET_ALERTS",
  FETCH_CALENDAR_PLAN: "FETCH_CALENDAR_PLAN",
  GET_PEOPLE_DATA: "GET_PEOPLE_DATA",
  FETCH_REASON_CODE_LIST: "FETCH_REASON_CODE_LIST",
  FETCH_VIZUALIZATION: "FETCH_VIZUALIZATION",
  FETCH_TIER_LIST: "FETCH_TIER_LIST",
  FETCH_ABOVE_TIER_LIST: "FETCH_ABOVE_TIER_LIST",
  UPDATE_TEMPLATE_LOCAL: "UPDATE_TEMPLATE_LOCAL",
  UPDATE_TEMPLATE: "UPDATE_TEMPLATE",
  PREVIEW: "PREVIEW",
  FETCH_PINNED_SITES: "FETCH_PINNED_SITES",
  GET_SESSION_INFO: "GET_SESSION_INFO",
  GET_USER_BY_CODE: "GET_USER_BY_CODE",
  VALIDATE_SESSION: "VALIDATE_SESSION",
  QUICK_LINK_INFO: "QUICK_LINK_INFO",
  FETCH_INCIDENT: "FETCH_INCIDENT",
  UPDATE_INCIDENT: "UPDATE_INCIDENT",
  DELETE_INCIDENT: "DELETE_INCIDENT",
  FETCH_CALENDAR_UPCOMING_EVENT: "FETCH_CALENDAR_UPCOMING_EVENT",
  FETCH_GEMBA_TYPES: "FETCH_GEMBA_TYPES",
  FETCH_INCIDENT_TYPE_LIST: "FETCH_INCIDENT_TYPE_LIST",
  GET_INCIDENT_TYPE: "GET_INCIDENT_TYPE",
  SAVE_LAYOUT_FILE: "SAVE_LAYOUT_FILE",
  FETCH_CALENDAR_EVENT_TYPES: "FETCH_CALENDAR_EVENT_TYPES",
  FETCH_PUBLISHED_TPL: "FETCH_PUBLISHED_TPL",
  FETCH_SITE_LISTS: "FETCH_SITE_LISTS",
  GET_USER_DETAILS: "GET_USER_DETAILS",
  FETCH_ALL_USERS: "FETCH_ALL_USERS",
  FETCH_TABLEAU_ACCESS: "FETCH_TABLEAU_ACCESS",
  SAVE_HTML_TPL: "SAVE_HTML_TPL",
  FETCH_SCHEDULES: "FETCH_SCHEDULES",
  FETCH_TZ: "FETCH_TZ",
  SAVE_SCHEDULE: "SAVE_SCHEDULE",
  DEL_SCHEDULE: "DEL_SCHEDULE",
  FETCH_USER_CLUSTER: "FETCH_USER_CLUSTER",
  ADD_USER_CLUSTER: "ADD_USER_CLUSTER",
  DELETE_USER_CLUSTER: "DELETE_USER_CLUSTER",
  UPDATE_USER_CLUSTER: "UPDATE_USER_CLUSTER",
  FETCH_GALLERY: "FETCH_GALLERY",
  ADD_GALLERY_FILE: "ADD_GALLERY_FILE",
  FETCH_WB_INFO: "FETCH_WB_INFO",
  FETCH_NEXUS_MAIL: "FETCH_NEXUS_MAIL",
  GET_TABLEUA_INFO: "GET_TABLEUA_INFO",
  GET_USER_HIGHEST_TIER: "GET_USER_HIGHEST_TIER",
  GET_PINNED_MAIL: "GET_PINNED_MAIL",
  GET_USER_MAIL: "GET_USER_MAIL",
  GET_SITE_HIGHEST_TIER: "GET_SITE_HIGHEST_TIER",
  FETCH_KAIZEN_CATEGORIES: "FETCH_KAIZEN_CATEGORIES",
  FETCH_KAIZEN_AREA: "FETCH_KAIZEN_AREA",
  FETCH_KAIZEN_CELL: "FETCH_KAIZEN_CELL",
  FETCH_KAIZEN_USER_DATA: "FETCH_KAIZEN_USER_DATA",
  FETCH_KAIZEN_ALL_USERS: "FETCH_KAIZEN_ALL_USERS",
  FETCH_MANAGER_DETAILS: "FETCH_MANAGER_DETAILS",
  UPDATE_KAIZEN_STATUS: "UPDATE_KAIZEN_STATUS",
  ADD_KAIZEN_RAISE_CI: "ADD_KAIZEN_RAISE_CI",
  GET_KAIZEN_CI_LIST: "GET_KAIZEN_CI_LIST",
  FETCH_KAIZEN_SITE_FOCAL_INFO: "FETCH_KAIZEN_SITE_FOCAL_INFO",
  GET_IMAGE: "GET_IMAGE",
  GET_NOMINATION: "GET_NOMINATION",
  FETCH_KRECOG: "FETCH_KRECOG",
  MANAGE_NOMINATION: "MANAGE_NOMINATION",
  FETCH_KAIZEN_DATA_BY_ID: "FETCH_KAIZEN_DATA_BY_ID",
  FETCH_NOMINATION_KAIZEN_DATA: "FETCH_NOMINATION_KAIZEN_DATA",
  FETCH_KRECOG: "FETCH_KRECOG",
  FETCH_OPH_LIST_BY_TIER: "FETCH_OPH_LIST_BY_TIER",
  FETCH_OPH_BY_ID: "FETCH_OPH_BY_ID",
  FETCH_KCATEGORY: "FETCH_KCATEGORY",
  UPDATE_OPH_STATUS: "UPDATE_OPH_STATUS",
  FETCH_KRECOG: "FETCH_KRECOG",
  FETCH_ADMIN_NOMINATED_KAIZEN_DATA: "FETCH_ADMIN_NOMINATED_KAIZEN_DATA",
  MANAGE_ADMIN_NOMINATED_KAIZEN_DATA: "MANAGE_ADMIN_NOMINATED_KAIZEN_DATA",
  FETCH_CATEGORY_SAVE: "FETCH_CATEGORY_SAVE",
  FETCH_KAIZEN_ADMIN_DELETE_LIST: "FETCH_KAIZEN_ADMIN_DELETE_LIST",
  FETCH_OPH_MISS_REASON_CODES: "FETCH_OPH_MISS_REASON_CODES",
  FETCH_HSE: "FETCH_HSE",
  FETCH_HSECOMMUNICATION: "FETCH_HSECOMMUNICATION",
  FETCH_SHIFTSCHEDULE: "FETCH_SHIFTSCHEDULE",
  FETCH_SHIFT_LIST: "FETCH_SHIFT_LIST",
  FETCH_OPH_DETAILS: "FETCH_OPH_DETAILS",
  GET_APPROVER_HIGHEST_TIER: "GET_APPROVER_HIGHEST_TIER",
  MANAGE_RPS: "MANAGE_RPS",
  GET_REASON_CODE_BY_FREQUENCY: "GET_REASON_CODE_BY_FREQUENCY",
  GET_RPS_RAIL: "GET_RPS_RAIL",
  MANAGE_RPSRAIL: "MANAGE_RPSRAIL",
  FETCH_RPS_GRID: "FETCH_RPS_GRID",
  GET_OPH_FILE: "GET_OPH_FILE",
  FETCH_PS_DATA: "FETCH_PS_DATA",
  MANAGE_PS_DATA: "MANAGE_PS_DATA",
  FETCH_RCA_GRID: "FETCH_RCA_GRID",
  FETCH_RPS_GRID: "FETCH_RPS_GRID",
  FETCH_ALL_RPS_DATA: "FETCH_ALL_RPS_DATA",
  GET_SOLUTION_DATA: "GET_SOLUTION_DATA",
  UPDATE_SOLUTION_DATA: "UPDATE_SOLUTION_DATA",
  DELETE_SOLUTION_DATA: "DELETE_SOLUTION_DATA",
  FETCH_CR_DATA: "FETCH_CR_DATA",
  POST_CONFIRMRESULTS_GRID: "POST_CONFIRMRESULTS_GRID",
  FETCH_RCA_ATTACHMENT_DATA: "FETCH_RCA_ATTACHMENT_DATA",
  FETCH_RESULTS_ATTACHMENT_DATA: "FETCH_RESULTS_ATTACHMENT_DATA",
  FETCH_BREAKDOWN_ATTACHMENT_DATA: "FETCH_BREAKDOWN_ATTACHMENT_DATA",
  FETCH_RAPID_EXPERIMENT: "FETCH_RAPID_EXPERIMENT",
  MANAGE_EXPERIMENT: "MANAGE_EXPERIMENT",
  FETCH_Experiment_ATTACHMENT: "FETCH_Experiment_ATTACHMENT",
  MANAGE_EXPERIMENT: "MANAGE_EXPERIMENT",
  GET_DLE_MISS_REASON_PARETO_DATA: "GET_DLE_MISS_REASON_PARETO_DATA",
  FETCH_REASON_CODE_LIST_FORADMIN: "FETCH_REASON_CODE_LIST_FORADMIN",
  GET_METRIC_ANDON: "GET_METRIC_ANDON",
  GET_DLE_DETAILS: "GET_DLE_DETAILS",
  GET_FPY_MISS_REASON_PARETO_DATA: "GET_FPY_MISS_REASON_PARETO_DATA",
  GET_LID_PLANT_DATA: "GET_LID_PLANT_DATA",
  GET_USER_DATA_ACCESS: "GET_USER_DATA_ACCESS",
  GET_GEMBA_WALK_PRIORITIES_DATA: "GET_GEMBA_WALK_PRIORITIES_DATA",
  FETCH_SMESS_REASON_CODE_LIST_FORADMIN:
    "FETCH_SMESS_REASON_CODE_LIST_FORADMIN",
  FETCH_LINES_LIST: "FETCH_LINES_LIST",
  FETCH_MATERIAL_LIST: "FETCH_MATERIAL_LIST",
  GET_TIMEZONE_LIST: "GET_TIMEZONE_LIST",
  FETCH_SA_TARGET: "FETCH_SA_TARGET",
  FETCH_SA_REASON_CODES: "FETCH_SA_REASON_CODES",
  FETCH_SA_DAILY_INPUT_DETAILS: "FETCH_SA_DAILY_INPUT_DETAILS",
  REFRESH_SCH_ATTAINMENT_WIDGET: "REFRESH_SCH_ATTAINMENT_WIDGET",
  FETCH_BULK_MATERIAL_LIST: "FETCH_BULK_MATERIAL_LIST",
  FETCH_SCH_ATTAINMENT_RUN_CHART: "FETCH_SCH_ATTAINMENT_RUN_CHARTs",
  FETCH_SCH_ATTAINMENT_MISS_REASON_CODE_FREQ:
    "FETCH_SCH_ATTAINMENT_MISS_REASON_CODE_FREQ",
  FETCH_SCHEDULED_REPORT: "FETCH_SCHEDULED_REPORT",
  FETCH_SCHEDULED_REPORT_LIST_DATA: "FETCH_SCHEDULED_REPORT_LIST_DATA",
  FETCH_SETTINGS_MULTI_SURVEY_DATA: "FETCH_SETTINGS_MULTI_SURVEY_DATA",
  MANAGE_SETTINGS_MULTI_SURVEY_DATA: "MANAGE_SETTINGS_MULTI_SURVEY_DATA",
  FETCH_SETTINGS_MULTI_SURVEY_TIERS_DATA:
    "FETCH_SETTINGS_MULTI_SURVEY_TIERS_DATA",
  FETCH_QUESTIONARE_DATA: "FETCH_QUESTIONARE_DATA",
  GET_OPH_MISS_REASON_GRAPH: "GET_OPH_MISS_REASON_GRAPH",
  FETCH_MULTI_SURVEY_NAME_DATA: "FETCH_MULTI_SURVEY_NAME_DATA",
  FETCH_OPH_ATTAINMENT_RUN_CHART: "FETCH_OPH_ATTAINMENT_RUN_CHART",
  FETCH_OPH_ATTAINMENT_TARGET: "FETCH_OPH_ATTAINMENT_TARGET",
  FETCH_MULTI_SURVEY_DATA_BY_SURVEY_FILTER:
    "FETCH_MULTI_SURVEY_DATA_BY_SURVEY_FILTER",
  FETCH_MULTI_SURVEY_SHIFT_DATA: "FETCH_MULTI_SURVEY_SHIFT_DATA",
  FETCH_MULTI_SURVEY_SHIFT_QUESTION_DATA:
    "FETCH_MULTI_SURVEY_SHIFT_QUESTION_DATA",
  FETCH_MULTI_SURVEY_PARETO_CHART_DATA: "FETCH_MULTI_SURVEY_PARETO_CHART_DATA",
  FETCH_MULTI_SURVEY_RUN_CHART_DATA: "FETCH_MULTI_SURVEY_RUN_CHART_DATA",
  REFRESH_MULTI_SURVEY_WIDGET: "REFRESH_MULTI_SURVEY_WIDGET",
  FETCH_TARGETSTATE_A3: "FETCH_TARGETSTATE_A3",
  FETCH_A3_DATA: "FETCH_A3_DATA",
  MANAGE_A3_DATA: "MANAGE_A3_DATA",
  MANAGE_TARGET_STATE: "MANAGE_TARGET_STATE",
  FETCH_ATTACHMENT_A3: "FETCH_ATTACHMENT_A3",
  MANAGE_ATTACHMENT_A3: "MANAGE_ATTACHMENT_A3",
  DELETE_ATTACHMENT_A3: "DELETE_ATTACHMENT_A3",
  FETCH_A3_GAP_DATA: "FETCH_A3_GAP_DATA",
  FETCH_A3_GAP_SOLUTION_DATA: "FETCH_A3_GAP_SOLUTION_DATA",
  FETCH_A3_GAP_ANALYSIS_DATA: "FETCH_A3_GAP_ANALYSIS_DATA",
  MANAGE_GAP_ANALYSIS_DATA: "MANAGE_GAP_ANALYSIS_DATA",
  FETCH_EXPERIMENT_A3: "FETCH_EXPERIMENT_A3",
  MANAGE_EXPERIMENTS_DATA: "MANAGE_EXPERIMENTS_DATA",
  FETCH_A3_COMPLETION_PLAN: "FETCH_A3_COMPLETION_PLAN",
  MANAGE_A3_COMPLETION_PLAN: "MANAGE_A3_COMPLETION_PLAN",
  FETCH_A3_GRID_DATA: "FETCH_A3_GRID_DATA",
  FETCH_A3_CONFIRMEDRESULTS: "FETCH_A3_CONFIRMEDRESULTS",
  FETCH_A3_CONFIRMEDRESULTS_GRAPH: "FETCH_A3_CONFIRMEDRESULTS_GRAPH",
  MANAGE_RESULTS_DATA: "MANAGE_RESULTS_DATA",
  MANAGE_RESULTS_FREQUENCY_DATA: "MANAGE_RESULTS_FREQUENCY_DATA",
  FETCH_LANGUAGE: "FETCH_LANGUAGE",
  GET_LANGUAGES_BY_REGION: "GET_LANGUAGES_BY_REGION",
  GET_INPUT_TYPE_REASON_CODE_BY_LANG_ID:
    "GET_INPUT_TYPE_REASON_CODE_BY_LANG_ID",
  SEND_TOAST_MESSAGE: "SEND_TOAST_MESSAGE",
  GET_MODULE_DATA: "GET_MODULE_DATA",
  GET_REASON_CODE_FREQUENCY_BY_MODULE: "GET_REASON_CODE_FREQUENCY_BY_MODULE",
  FETCH_OPH_MISS_REASON_GRAPH: "FETCH_OPH_MISS_REASON_GRAPH",
  FETCH_OPH_ATTAINMENT_GRAPH: "FETCH_OPH_ATTAINMENT_GRAPH",
};
export default ACTION_TYPES;
